import { TableDataKey } from '../types/table-data-key';

export class TableRowsSelectionChangeEvent<Item> {
  public constructor(
    public readonly isAllSelected: boolean,
    public readonly includedIds: Array<Item[TableDataKey<Item>]>,
    public readonly excludedIds: Array<Item[TableDataKey<Item>]>,
  ) {}
}
